
















import PullRefresh from '@/packages/m-pull-refresh';
import MTabs from '@/packages/m-tabs';
import Vue from 'vue';
import Component from 'vue-class-component';

Vue.use(PullRefresh);
Vue.use(MTabs);

@Component({
  name: 'Components'
})
export default class Components extends Vue {

  public refreshing = false;

  public refresh() {
    this.refreshing = true;
    setTimeout(() => {
      this.refreshing = false;
    }, 2000);
  }
}
